import {
    sg_broker_id_token_endpoint,
    sg_broker_origin,
    sg_broker_redirect_uri,
    sg_broker_authorize_endpoint,
    sg_broker_clientId,
    sg_broker_demo_age_to_verify,
} from './ageVerificationConfig';

// Define types for responses and claims
type BrokerApiResponse = {
    validated: boolean;
    claims: {
        nonce: string;
        idbrokerdk_age_verified: string;
    };
    error_description?: string;
};

type ValidationResult = {
    age_to_verify: number;
    age_verified: boolean;
    claims?: { nonce: string; idbrokerdk_age_verified: string };
    error_description?: string;
};

// Function to validate the ID token with the broker's API
const handleBrokerOnlineValidateIdToken = async (idToken: string): Promise<ValidationResult> => {
    const bodyData = { idToken };
    const response = await fetch(sg_broker_id_token_endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyData),
    });
    const jsonResponse: BrokerApiResponse = await response.json();

    return {
        age_to_verify: sg_broker_demo_age_to_verify,
        age_verified: jsonResponse.validated,
        claims: jsonResponse.claims,
    };
};

// Function to handle the response from the broker
const handleBrokerResponse = async (
    event: MessageEvent,
    resolve: (result: ValidationResult) => void,
) => {
    const result: { id_token?: string; error_description?: string } = JSON.parse(event.data.result);

    if (result.id_token) {
        const validationResult = await handleBrokerOnlineValidateIdToken(result.id_token);
        resolve(validationResult);
    } else {
        resolve({
            age_to_verify: sg_broker_demo_age_to_verify,
            age_verified: false,
            error_description: result.error_description,
        });
    }
};

// Check if the received event is an age verification event
const handleBrokerIsAgeEvent = (event: MessageEvent): boolean => {
    return event.origin === sg_broker_origin && event.data.command === 'webmessage_flow_response';
};

// Main function to start the age verification process
export const handleBrokerStartAgeVerification = (nonce: string): Promise<ValidationResult> => {
    let windowRef: Window | null;

    const popupWindow = (url: string, title: string, width: number, height: number) => {
        if (
            navigator.userAgent.indexOf('Safari') != -1 &&
            navigator.userAgent.indexOf('Chrome') == -1
        ) {
            height = height + 30; // Safe margin for Safari on Mac OS
        }
        const verticalCenter = window.outerHeight / 2 + window.screenY - height / 2;
        const horizontalCenter = window.outerWidth / 2 + window.screenX - width / 2;
        const features = [
            'toolbar=no',
            'location=no',
            'directories=no',
            'status=no',
            'menubar=no',
            'scrollbars=no',
            'resizable=no',
            'copyhistory=no',
            `innerWidth=${width}`,
            `innerHeight=${height}`,
            `top=${verticalCenter}`,
            `left=${horizontalCenter}`,
        ].join(', ');
        windowRef = window.open(url, title, features);

        windowRef?.focus();
    };

    function ShowPopup() {
        const url = `${sg_broker_authorize_endpoint}?client_id=${sg_broker_clientId}&redirect_uri=${sg_broker_redirect_uri}&response_type=id_token&scope=openid%20age_verify:${sg_broker_demo_age_to_verify}&idp_values=idbrokerdk&prompt=login&nonce=${nonce}`;
        const title = 'Verificer Alder';
        const width = 452;
        const height = 640;
        popupWindow(url, title, width, height);
    }

    ShowPopup();

    return new Promise((resolve) => {
        function receiveEvent(event: MessageEvent) {
            if (handleBrokerIsAgeEvent(event)) {
                windowRef?.close();
                handleBrokerResponse(event, resolve);
            }
        }

        window.addEventListener('message', receiveEvent, false);
    });
};
